export default __webpack_public_path__ + "58333fd3cd79dc6929a1cdb706531ac6.png";